import handleCart from "./handleCart"
import {combineReducers} from "redux"

const rootReducters = combineReducers({
    handleCart,
});

export default rootReducters;